<template lang="pug" src="./referralCodes.pug"> </template>
<style src="./referralCodes.scss" lang="scss" scoped> </style>

<script>
import { mapState } from 'vuex'
import copyToClipboard from '@/utils/copy'
import scroll from '@/utils/scroll'

export default {
    data: () => ({
        name: '',
        createDialog: false,
        removeDialog: false,
        qrDialog: false,
        code: null,
        qrValue: null,
        isDisabled: false,
        image: null,
        sorting: {}
    }),
    computed: {
        ...mapState({
            type: state => state.app.type,
            referralCodes: state => state.codes.referralCodes,
            isTableLoad: state => state.codes.isLoaded,
            pagination: state => state.codes.pagination
        }),
        headers() {
            return [
                { text: '№', sortable: false, number: true },
                { text: 'name', value: 'name' },
                { text: 'code', value: 'code' },
                { text: '', sortable: false, number: true }
            ].map(it => Object.assign(it, {
                text: it.number ? it.text : this.$vuetify.lang.t(`$vuetify.pages.ReferralCodes.table.${it.text}`)
            }))
        },
        urls: function() {
            return [
                { type: 'business', url: `${process.env.VUE_APP_FRONT}/ref-register/${this.code}` },
                { type: 'leader', url: `${process.env.VUE_APP_FRONT}/business-register/${this.code}` }
            ]
        },
        canShare() {
            return !!navigator.share
        }
    },

    watch: {
        createDialog(isShow) {
            if (!isShow) {
                this.cancelCreateDialog()
            }
        },
        sorting: {
            handler() {
                this.getReferralCodesByPage()
            },
            deep: true
        }
    },

    created: function() {
        this.getReferralCodesByPage()
    },

    methods: {
        getReferralCodesByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('codes/getReferralCodes', {
                page, excel,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc'
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },

        addReferralCode: async function(name) {
            this.name = ''
            this.createDialog = false
            await this.$store.dispatch('codes/addReferralCode', name).then(() => {
                this.getReferralCodesByPage()
            })
        },

        removeReferralCode: async function() {
            this.isDisabled = true

            const referralCode = this.code
            if (referralCode) {
                await this.$store.dispatch('codes/removeReferralCode', referralCode.id).then(() => {
                    this.isDisabled = false
                    this.getReferralCodesByPage()
                })
            }

            this.removeDialog = false
        },

        editReferralCode: async function(referralCode, name) {
            await this.$store.dispatch('codes/editReferralCode',
                Object.merge(referralCode, { name })
            )
        },

        cancelCreateDialog() {
            this.name = ''
            this.createDialog = false
        },

        openCreateDialog() {
            this.createDialog = true
            this.$nextTick(_ => {
                this.$refs.name.focus()
            })
        },

        openRemoveDialog(code) {
            this.removeDialog = true
            this.code = code
        },

        openQrDialog(code) {
            this.code = code
            this.qrDialog = true
            this.urls.forEach(item => {
                if (item.type === this.type) {
                    this.qrValue = item.url
                }
            })

            this.image = this.$refs.qrCode.$el
        },

        copy(code) {
            this.code = code
            this.urls.forEach(item => {
                if (item.type === this.type) {
                    copyToClipboard(item.url)
                }
            })
        },

        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getReferralCodesByPage(page, true)
            }
        },

        async download() {
            this.$refs.downloadLink.$el.href = await this.image.toDataURL('image/jpg')
        },

        share(code) {
            const message = this.type === 'business' ? 'businessShareText' : 'leaderShareText'
            const linkShareText = this.$vuetify.t(`$vuetify.pages.Referrals.${message}`)

            this.code = code
            const item = this.urls.find(it => it.type === this.type)

            if (item.type === this.type && this.canShare) {
                navigator.share({
                    title: 'SPRUT',
                    text: linkShareText,
                    url: item.url
                }).then(() => {
                    this.$store.dispatch('addMessage', {
                        message: 'linkShared',
                        type: 'success',
                        locale: true
                    })
                }).catch(() => {
                    // Catch iOS bug
                    window.location.reload(true)
                })
            }
        },

        exportToExcel() {
            this.getReferralCodesByPage(1, false, true)
        }
    }
}
</script>
